export class ChangeQuotaPeriod {
    public static readonly type: string = '[QUOTA] Change Quota Period';
    constructor(public key: string) { }
}
